module.exports = __webpack_public_path__ + "742bd6858f27332430e21a892bc4dfb6.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/Arrows/images/arrow.svg
// module id = 1257
// module chunks = 1